import React from 'react';

import PropTypes from 'prop-types';

import DrawerContent from './DrawerContent';
import StyledDrawer from './StyledDrawer';

const SideBar = ({
    drawerSize,
    handleDrawerToggle,
    match,
    mobileOpen,
    profileValues,
    redirect,
    selectedTheme,
    setTheme,
    toggleDrawerSize,
}) => {
    const container =
        window !== undefined ? () => window.document.body : undefined;
    const drawerContent = (
        <DrawerContent
            {...{
                container,
                drawerSize,
                handleDrawerToggle,
                match,
                mobileOpen,
                profileValues,
                redirect,
                selectedTheme,
                setTheme,
                toggleDrawerSize,
            }}
        />
    );
    return (
        <>
            <StyledDrawer
                drawersize={drawerSize}
                variant="permanent"
                sx={{
                    '& .MuiDrawer-paper': {
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'dark'
                                ? theme.palette.secondary.main
                                : 'rgba(242, 244, 249, 1)',
                    },
                    display: { xs: 'none', md: 'block' },
                }}
            >
                {drawerContent}
            </StyledDrawer>

            <StyledDrawer
                container={container}
                drawersize={drawerSize}
                ModalProps={{ keepMounted: true }}
                open={mobileOpen}
                onClose={handleDrawerToggle}
                variant="temporary"
                sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: '100%',
                    },
                }}
            >
                {drawerContent}
            </StyledDrawer>
        </>
    );
};

SideBar.propTypes = {
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    match: PropTypes.object,
    mobileOpen: PropTypes.bool,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setTheme: PropTypes.func,
    toggleDrawerSize: PropTypes.func,
};

export default SideBar;
